import {
  type AgentOutboundView,
  AgentRecipientScope,
  AgentSlackPeopleScope,
} from '@this+that/models';

export { AgentRecipientScope, AgentSlackPeopleScope };

export const DEFAULT_RECIPIENT_SCOPE = AgentRecipientScope.SAVED_ONLY;

export const DEFAULT_SLACK_PEOPLE_SCOPE = AgentSlackPeopleScope.NONE;

/** An outbound config as GraphQL serves it. */
export type AgentOutboundWithScope = Partial<AgentOutboundView>;

export function readRecipientScope(
  outbound: AgentOutboundWithScope | null | undefined,
): AgentRecipientScope {
  return outbound?.recipientScope ?? DEFAULT_RECIPIENT_SCOPE;
}

export function readSlackPeopleScope(
  outbound: AgentOutboundWithScope | null | undefined,
): AgentSlackPeopleScope {
  return outbound?.slackPeopleScope ?? DEFAULT_SLACK_PEOPLE_SCOPE;
}
